import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { V3SchoolTeacher, V3Teacher } from '../../../model/v3/schools';
import { TeacherV3Api } from '../casa-native-api';
import { Page, Pageable } from '../../../../utils/pageable';
import { appendIfDefined } from './rest-v3-utils';

@Injectable({
  providedIn: 'root',
})
export class TeacherV3RestService implements TeacherV3Api {
  constructor(private http: HttpClient) {}

  private url(schoolId: number, path: string = ''): string {
    return `${environment.eventsApiBase}/v1/schools/${schoolId}/teachers${path}`;
  }

  private perspectivesUrl(path: string = ''): string {
    return `${environment.eventsApiBase}/v1/teachers${path}`;
  }

  getTeachers(
    schoolId?: number | null,
    personId?: number | null,
    email?: string | null,
    teacherIds?: number[] | null,
    pageable?: Pageable | null
  ): Observable<Page<V3SchoolTeacher>> {
    let params = new HttpParams();
    params = appendIfDefined(params, 'schoolId', schoolId);
    params = appendIfDefined(params, 'personId', personId);
    params = appendIfDefined(params, 'email', email);
    (teacherIds ?? []).forEach((id) => {
      params = params.append('ids', id.toString());
    });
    params = pageable?.appendParams(params) ?? params;
    return this.http.get<Page<V3SchoolTeacher>>(this.perspectivesUrl(), { params });
  }

  findTeachers(
    schoolId: number,
    term?: string | null,
    productCode?: string | null,
    pageable?: Pageable | null
  ): Observable<Page<V3Teacher>> {
    let params = new HttpParams();
    params = appendIfDefined(params, 'term', term);
    params = appendIfDefined(params, 'productCode', productCode);
    params = pageable?.appendParams(params) ?? params;
    return this.http.get<Page<V3Teacher>>(this.url(schoolId), { params });
  }

  getTeacher(schoolId: number, teacherId: number): Observable<V3Teacher> {
    return this.http.get<V3Teacher>(this.url(schoolId, `/${teacherId}`));
  }
}
